import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { getToken } from '../../services/authToken';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * useInterviewSimSessions — GET /api/cabin/interview-sim/sessions
 * Returns list of student's simulation sessions
 */
export function useInterviewSimSessions() {
  const [sessions, setSessions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchSessions = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const token = getToken();
      const res = await axios.get(`${API}/cabin/interview-sim/sessions`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setSessions(Array.isArray(res.data) ? res.data : (res.data?.sessions || []));
    } catch (err) {
      setSessions([]);
      setError(err?.response?.data?.message_tr || err?.response?.data?.detail || err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchSessions();
  }, [fetchSessions]);

  return { sessions, loading, error, refetch: fetchSessions };
}
